<template>
  <BaseCard>
    <BaseCardHeader>
      <div class="flex justify-between items-baseline -mr-2">
        <h5 class="font-light">Concept</h5>
        <BaseIconButton v-if="!edit" icon="edit" brand @click="edit = !edit" />
        <template v-else>
          <div class="space-x-2 justify-end">
            <BaseIconButton icon="times" silver @click="doRevert" />
            <BaseIconButton green icon="check" @click="doSubmit" />
          </div>
        </template>
      </div>
    </BaseCardHeader>
    <BaseCardBody>
      <ul class="-m-4">
        <BaseList nested>
          <BaseListHeader>
            <span class="uppercase text-sm">Audience</span>
          </BaseListHeader>
          <BaseListBody>
            <BaseListItem>
              <div v-if="edit" class="-mx-2">
                <input
                  class="input"
                  type="number"
                  v-model.lazy="localCustomFields.audience"
                  :disabled="updating"
                  step="1"
                  placeholder="Number"
                />
              </div>
              <div v-else class="py-2">
                <span v-if="localCustomFields.audience">{{ localCustomFields.audience }}</span>
                <span v-else>Δεν έχει οριστεί</span>
              </div>
            </BaseListItem>
          </BaseListBody>
        </BaseList>

        <BaseList nested>
          <BaseListHeader>
            <span class="uppercase text-sm">Anatomy</span>
          </BaseListHeader>
          <BaseListBody>
            <BaseListItem>
              <div class="-mx-2">
                <textarea
                  v-if="edit"
                  v-model="localCustomFields.anatomy"
                  :readonly="!edit"
                  :disabled="updating"
                  class="input h-84"
                />
                <div
                  v-else
                  class="p-2 resize-none w-full block whitespace-pre-wrap"
                  v-text="localCustomFields.anatomy"
                />
              </div>
            </BaseListItem>
          </BaseListBody>
        </BaseList>
      </ul>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import store from '@/store';

export default {
  name: 'ClientAnatomy',
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    const { options = {} } = store.state.app;

    return {
      edit: false,
      updating: false,
      defaultCustomFields: {
        anatomy: options.default_client_anatomy || null,
        audience: null,
      },
      localCustomFields: null,
    };
  },
  watch: {
    $currentAccount: {
      handler() {
        this.setup();
      },
      deep: true,
    },
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      const { customFields } = this.$currentAccount || {};
      this.localCustomFields = JSON.parse(
        JSON.stringify({ ...this.defaultCustomFields, ...(customFields || {}) })
      );
    },
    doRevert() {
      this.setup();
      this.edit = false;
    },
    async doSubmit() {
      const { dispatch } = this.$store;
      const { accountId } = this;
      const accountUpdatedData = {
        custom_fields: { ...this.localCustomFields },
      };

      this.updating = true;

      await dispatch('ui/accounts/updateAccount', { accountId, accountUpdatedData });

      this.updating = false;
      this.edit = false;
    },
  },
};
</script>
